// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scan-progress[data-v-3b44df24]{padding-top:32px;padding-bottom:32px}.scan-top-description[data-v-3b44df24]{font-weight:400;color:#858f9b;padding-top:16px}.scan-bottom-description[data-v-3b44df24]{font-weight:400;color:#858f9b;padding-top:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
